// eslint-disable-next-line
export const removeChatbox = function () {
  const chatbox = document.getElementById("embedded-messaging");
  if (chatbox) {
    chatbox.remove();
  }
};

// eslint-disable-next-line
const initStylesAndConfig = () => {
  try {
    window.embeddedservice_bootstrap.settings.language = "en_US";

    window.addEventListener("onEmbeddedMessagingReady", () => {
      window.embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
        Product: {
          value: "Giant Steps",
          isEditableByEndUser: true,
        },
      });
    });

    window.embeddedservice_bootstrap.init(
      "00D41000000GNzs",
      "GoGuardian_Offline_Support",
      "https://goguardian.my.site.com/ESWGoGuardianOfflineSup1770722407612",
      {
        scrt2URL: "https://goguardian.my.salesforce-scrt.com",
      }
    );
  } catch (err) {
    console.error("Error loading Embedded Messaging: ", err);
  }
};

// eslint-disable-next-line
export const initSFChat = () => {
  if (!window.embeddedservice_bootstrap) {
    const s = document.createElement("script");
    s.setAttribute(
      "src",
      "https://goguardian.my.site.com/ESWGoGuardianOfflineSup1770722407612/assets/js/bootstrap.min.js"
    );
    s.onload = function () {
      initStylesAndConfig();
    };
    document.body.appendChild(s);
  }
};
